// ACHTUNG!! Muss JSON sein, keine Komentare!
export default {
  "entrypoints": {
    "contact": {"php": false},
    "cookie-notice": {"php": false},
    "swiper": {"php": false},
    "lightgallery": {"php": false},
    "immo-expose": {"php": false},
    "immoapp-exposecontact": {"php": false},
    "immoapp": {"php": false},
    "testimonial-app": {"php": false},
    "tabs": {"php": false},
    "expose-map": {"php": false},
    "accordion": {"php": false},
  }
}
